import { Component, Input } from '@angular/core';

export interface TabsNavOption {
  label: string;
  routerLink?: string;
  disabled?: boolean;
}

@Component({
  selector: 'vfs-button-tabs-nav',
  templateUrl: './button-tabs-nav.component.html',
  styleUrls: ['./button-tabs-nav.component.scss']
})
export class ButtonTabsNavComponent {
  @Input() options: TabsNavOption[];
}
